import { asStoryPages } from '@/features/story/types';

interface Props {
  storyText: string;
  storyTextPages: unknown;
}

/**
 * Renders story body text. Prefers the page-by-page array (future
 * books / Dreambook compatibility) and falls back to the flat
 * storyText blob when pages are missing or malformed.
 *
 * Paragraph splitting: split on one-or-more newline characters so
 * Claude's multi-line output renders as distinct paragraphs rather
 * than one wrapped wall of text.
 */
export function StoryBody({ storyText, storyTextPages }: Props) {
  const pages = asStoryPages(storyTextPages);

  if (pages) {
    return (
      <div className="space-y-4">
        {pages.map((page, i) => (
          <Paragraphs key={i} text={page} />
        ))}
      </div>
    );
  }

  return <Paragraphs text={storyText} />;
}

function Paragraphs({ text }: { text: string }) {
  const paragraphs = text
    .split(/\n\s*\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (paragraphs.length === 0) return null;
  return (
    <div className="space-y-3 text-base leading-relaxed text-dream-navy">
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  );
}
